<ng-container *ngIf="product$ | async as product">
  <div [jagaHideNoContent]='!product?.colorDescription' [innerHTML]="product.colorDescription"></div>
</ng-container>
